import axios from '@/utils/axiosHelper'

// 活动页初始化
export const onInitAPI = (params) => {
    return axios({ url: '/snail/three/index', method: 'GET', params }, { interceptResultCode: false })
}

// 答题
export const onAnswerAPI = (params) => {
    return axios({ url: '/snail/three/answer', method: 'POST', params }, { interceptResultCode: false })
}

// 点击彩蛋
export const onEggAPI = (params) => {
    return axios({ url: '/snail/three/click', method: 'POST', params }, { interceptResultCode: false })
}

// 领取奖励
export const onRewardAPI = (params) => {
    return axios({ url: '/snail/three/reward', method: 'POST', params }, { interceptResultCode: false })
}

// 助力页初始化
export const onHelpInitAPI = (params) => {
    return axios({ url: '/snail/three/help', method: 'GET', params }, { interceptResultCode: false })
}

// 点击助力
export const onHelpAPI = (params) => {
    return axios({ url: '/snail/three/help', method: 'POST', params }, { interceptResultCode: false })
}

// 注销
export const onLogoutAPI = (params) => {
    return axios({ url: '/game/my/disable', method: 'POST', params }, { interceptResultCode: false })
}

// 充值平台免登录
export const onUuidAPI = (params) => {
    return axios({ url: '/snail/clock/uuid', method: 'POST', params }, { interceptResultCode: false })
}


// WEBPACK FOOTER //
// ./src/pages/snail/webcast/api.js